<div class="bg-white rounded-[10px] flex flex-col overflow-hidden">
  @if (isLoading()) {
  <app-loader [size]="'w-8 h-8'" class="mx-auto my-[30px]" />
  } @else if (loadError()) {
  <p class="fg-rose-1 text-[14px] text-center p-5 m-0">
    {{ 'admin_settings.terminal_permissions.errors.load_message' | translate }}
  </p>
  } @else {
  @if (isOffline()) {
  <p class="fg-orange-1 text-[14px] text-center p-3 m-0 bg-orange-3">
    {{ 'admin_settings.terminal_permissions.errors.offline_message' | translate }}
  </p>
  }
  <div class="overflow-x-auto">
    <div class="flex items-center px-5 py-[15px] bg-white border-gris-3">
      <span class="flex-[2] min-w-0 fg-noir-2 text-[13px] font-semibold uppercase">
        {{ 'admin_settings.terminal_permissions.columns.user' | translate }}
      </span>
      @for (column of permissionColumns; track column) {
      <span class="flex-1 min-w-0 text-center fg-noir-2 text-[13px] font-semibold uppercase">
        {{ 'admin_settings.terminal_permissions.columns.' + column | translate }}
      </span>
      }
    </div>

    @for (row of rows(); track row.user.id) {
    <div class="flex items-center px-5 py-[10px] border-t border-gris-3">
      <span class="flex-[2] min-w-0 fg-gris-1 text-[14px] font-medium">
        {{ getUserDisplayName(row.user) | capitalize }}
      </span>
      @for (column of permissionColumns; track column) {
      <div class="flex-1 min-w-0 flex justify-center">
        <button type="button" [disabled]="savingUserId() === row.user.id || isOffline()"
          (click)="togglePermission(row, column)"
          class="relative h-[28px] w-[56px] rounded-full flex items-center transition-colors cursor-pointer px-[3px] disabled:opacity-50 disabled:cursor-not-allowed"
          [class.bg-vert-1]="row.permission?.[column]" [class.bg-gris-3]="!row.permission?.[column]"
          [class.justify-end]="row.permission?.[column]" [class.justify-start]="!row.permission?.[column]">
          <span class="size-[22px] rounded-full bg-white shrink-0 shadow"></span>
        </button>
      </div>
      }
    </div>
    } @empty {
    <p class="fg-noir-2 text-[14px] text-center p-5 m-0">
      {{ 'admin_settings.terminal_permissions.empty' | translate }}
    </p>
    }
  </div>
  }
</div>